import { BadImplementationException } from '@nu-art/ts-common';
import { LogicType_AboveNormal, LogicType_BelowNormal, LogicType_InNormal } from '../../../../_enum.js';
const NormalRangeOperatorConversion = {
    [LogicType_InNormal]: 'in',
    [LogicType_AboveNormal]: 'above',
    [LogicType_BelowNormal]: 'below',
};
export const resolveBaseNormalRangeAtom = (dbAtom, convertedAtom, dependencies) => {
    const dbVariable = dependencies.variables.find(_var => _var._id === dbAtom.leftHand.id);
    if (!dbVariable)
        throw new BadImplementationException(`Cannot find DB Variable: ${dbAtom.leftHand?.id}`);
    const dbExpression = dependencies.expressions.find(_expr => _expr.associatedVar === dbVariable._id);
    if (!dbExpression)
        throw new BadImplementationException(`Cannot find DB Expression with associated variable: ${dbVariable._id}`);
    convertedAtom.hv_name = dbVariable.name;
    convertedAtom.db_id = dbVariable._id;
    convertedAtom.expr_db_id = dbExpression._id;
};
const resolveNormalRangeParams = (_case) => {
    return {
        relation: NormalRangeOperatorConversion[_case.caseOperator],
        upper_scale: _case.factor?.upper ?? 1,
        lower_scale: _case.factor?.lower ?? 1
    };
};
export const resolveNormalRange = (dbAtom) => {
    const normalRange = {};
    // Set default values derived from the type
    normalRange.output_type = 'boolean';
    normalRange.type = 'in-normal-range-condition';
    // Convert the db value
    normalRange.params = resolveNormalRangeParams(dbAtom.cases[0]);
    return normalRange;
};
export const resolveNormalRangeConversion = (dbAtom, baseConversion) => {
    const normalRangeConversion = baseConversion;
    // Set default values derived from the type
    normalRangeConversion.type = 'in-normal-range-conversion';
    normalRangeConversion.options = dbAtom.cases.map(_case => ({
        return_value: normalRangeConversion.output_type === 'tuple' ? _case.value : _case.value[0],
        params: resolveNormalRangeParams(_case)
    }));
    return normalRangeConversion;
};
//# sourceMappingURL=normal-range.js.map